import React from "react";
import { graphql, useStaticQuery } from "gatsby";

export const useFilterGlobals = () => {
  const { wp } = useStaticQuery(graphql`
    query {
      wp {
        siteSettings {
          siteSettings {
            filterCrashTestedTooltip
            filterWindTunnelTestedTooltip
            filterChapter8Tooltip
            filterTitle
            filterSubtitle
          }
        }
      }
    }
  `);

  return wp.siteSettings.siteSettings
}
